<template>
  <div class="content">
    <h1 class="has-text-centered">Arduino Nano Pins</h1>
    <div class="box">
      <p class="is-size-7-mobile">
          Der Arduino Nano ist eine kleine, vollständige und Breadboard-freundliche Platine, die auf dem ATmega328 (Arduino Nano 3.x) basiert. Er hat mehr oder weniger die gleiche Funktionalität wie der Arduino Duemilanove, aber in einem anderen Gehäuse und arbeitet mit einem Mini-B-USB-Kabel anstelle eines Standardkabels.
      </p>
    </div>
    <div class="box has-text-centered">
      <img src="@/assets/images/pinouts/Pinout-NANO.png">
      <p class="is-size-7-mobile">
        Bild von <a target="_blank" href="https://www.arduino.cc/">https://www.arduino.cc/</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pins-arduino-nano',
  metaInfo: {
    title: 'Arduino Nano Pins | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Der Arduino Nano ist eine kleine, vollständige und Breadboard-freundliche Platine, die auf dem ATmega328 basiert.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'pins' })
  }
}
</script>
